import React from 'react';
import { wrapDisplayName } from 'recompose';
import { getResult } from '@deerplusofficial/pos-helper';
import { withClient } from '@deerplusofficial/pos-hoc';

export default (config) => (Component) =>
  withClient()(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'WithQueryMembers');

      queryMembers = async (keyword, price) => {
        const {
          client: { onError, /*POSApi,*/ COREApi },
        } = this.props;

        try {
          const { members } = getResult(
            await COREApi.get('/member/query', {
              params: { keyword, offset: 0, limit: 100, price },
            })
          );

          return members;
        } catch (err) {
          onError(err);
        }
      };

      render() {
        return <Component {...this.props} queryMembers={this.queryMembers} />;
      }
    }
  );



// WEBPACK FOOTER //
// ./src/model/Queries/withQueryMembers.js